import { WIZ_EVENT_TYPE, WizMathUtils } from '@wizeoo/akm-core-lib';
import {
  WizBasePopUp,
  WizDatasource,
  WizHgroup,
  WizList,
  WizTextInput,
  WizTranslationBasic,
  WizTranslationData,
  WizValidationError,
  WizValidationErrors,
  WizValidatorFn,
  WizEventManager, WizEvent
} from '@wizeoo/akm-component-lib';
import { Component, ElementRef, ViewChild } from '@angular/core';

import { ALK_EVENT_TYPE } from '../../../../../model/enums';
import { StyleVO } from '../../../../../vo/workingdata/style.vo';
import { Model } from '../../../../../model/model';
import { ViewData } from '../../../../../model/view.data';
import { StyleLineVO } from '../../../../../vo/workingdata/styleline.vo';
import { AlkEvent } from '../../../../../framework/events/alk.event';
import { ConditionRenderer } from './condition.renderer';

@Component({
  // popUp d'édition des champs de pivot: style, label, méthode d'aggrégat
  selector: 'header-edit-style-sub-pop',
  templateUrl: './header-edit-style.sub.pop.html',
})
export class HeaderEditStyleSubPop extends WizBasePopUp {
  @ViewChild('tiCode', { read: WizTextInput, static: false }) tiCode: WizTextInput; // champ de saisie du code
  /** Composant de saisie de la description */
  @ViewChild('trsDesc', { read: WizTranslationBasic, static: false }) trsDesc: WizTranslationBasic;
  @ViewChild('lstStyles', { read: WizList, static: false }) lstStyles: WizList; // liste des conditions

  @ViewChild('vgEdition', { read: WizHgroup }) vgEdition: WizHgroup; // ensemble de la zone de détail pour écoute ModelUpdate

  public lineRenderer: any = ConditionRenderer; // rendu des lignes de conditions

  protected doSaveFlag: boolean = true; // marqueur de validation des modifs (false sur cancel)
  public currentStyle: StyleVO = null; // sélection active (objet métier vrai)
  public clone: StyleVO = null; // clone de travail

  public code: string = '';
  public transDesc: WizTranslationData = null;

  public model: Model;

  constructor(public elementRef: ElementRef) {
    super();
  }

  /** DS des conditions */
  public conditionDS: WizDatasource<StyleLineVO> = new WizDatasource<StyleLineVO>([])
    .setSortFields([{ property: 'order', way: 'asc', numeric: true }])
    .setSelectionMode('none')
    .build();

  public show(): void {
    this.model =this.datas[0];
    this.currentStyle = this.datas[1];
    if (!this.currentStyle) {
      // mode création
      this.currentStyle = this.model.styleEngine.buildFake();
    }
    this.clone = this.model.styleEngine.clone(this.currentStyle);
    this.callback = this.datas[2];
    this.tiCode.wizRestrict = ViewData.CODE_REGEXP;
    this.lstStyles.wizDataProvider = this.conditionDS;
    this.feed();  
    this.addListeners();
  }

  /** alimentation de la zone de détail */
  private feed(): void {


    this.code = this.clone.code; // alimentation du code
    this.transDesc = this.model.localeEngine.buildTranslationData(this.clone.descriptionVO);

    if (this.clone.exist) {
      this.tiCode.wizDisabled = true;
    } else {
      this.tiCode.wizDisabled = false;
      setTimeout(() => {
        // sinon, pas le temps de rendre les compos enabled
        this.tiCode.wizFocus();
      }, 0);
    }
    setTimeout(() => {
      // sinon, pas le temps de rendre les compos enabled
      this.conditionDS.setSource(this.clone.linesVO);
    }, 0);  
  }

  private addListeners(): void {
    WizEventManager.addListener(this, this.vgEdition, WIZ_EVENT_TYPE.MODEL_UPDATE, this.updateModel); // écouteur global change pour modelUpdate
    WizEventManager.addListener(this, this.lstStyles, ALK_EVENT_TYPE.STYLE_STEP_UP, this.switchConditions);
    WizEventManager.addListener(this, this.lstStyles, ALK_EVENT_TYPE.STYLE_STEP_DOWN, this.switchConditions);
    WizEventManager.addListener(this, this.lstStyles, ALK_EVENT_TYPE.STYLE_STEP_DELETE, this.deleteConditions);
    WizEventManager.addListener(this, this.lstStyles, ALK_EVENT_TYPE.UPDATE_MODEL, this.updateModel); // écouteur global change pour modelUpdate
    WizEventManager.addListener(this, this.lstStyles, ALK_EVENT_TYPE.STYLE_ELEMENT_CHANGED, this.markForUpdate); // modif sur un élément de condition
  }

  /**
   * Suppression des ecouteurs de la vue
   */
  public wizRemoveListener(): void {
    WizEventManager.removeListener(this, this.vgEdition, WIZ_EVENT_TYPE.MODEL_UPDATE);
    WizEventManager.removeListener(this, this.lstStyles, ALK_EVENT_TYPE.STYLE_STEP_UP);
    WizEventManager.removeListener(this, this.lstStyles, ALK_EVENT_TYPE.STYLE_STEP_DOWN);
    WizEventManager.removeListener(this, this.lstStyles, ALK_EVENT_TYPE.STYLE_STEP_DELETE);
    WizEventManager.removeListener(this, this.lstStyles, ALK_EVENT_TYPE.STYLE_ELEMENT_CHANGED);
  }

  /** modification du contenu d'une condition */
  private markForUpdate(e: AlkEvent): void {
    this.clone.maintenanceFlag = WizMathUtils.createUUID(); // forcer l'update sur modif de children
    WizEventManager.dispatchEvent(this.elementRef, new AlkEvent(ALK_EVENT_TYPE.UPDATE_MODEL, true));
  }

  private deleteConditions(e: AlkEvent): void {
    const toDie: StyleLineVO = e.data;
    this.clone.removeLine(toDie);
    this.conditionDS.removeItem(toDie);
    let idx: number = 0;
    // recalcul des positions
    this.clone.linesVO
      .sort((a, b) => a.order - b.order)
      .forEach((line: StyleLineVO) => {
        line.order = idx;
        idx++;
      });
    this.clone.maintenanceFlag = WizMathUtils.createUUID(); // forcer l'update sur modif de children
    ViewData.wizUpdateModel = true;
  }

  /** permutation de 2 conditions */
  private switchConditions(e: AlkEvent): void {
    const me: StyleLineVO = e.data;
    const targetoffset: number = e.type === ALK_EVENT_TYPE.STYLE_STEP_UP ? -1 : +1;
    const other: StyleLineVO = this.clone.getLineByIdx(me.order + targetoffset);
    other.order = me.order;
    me.order = me.order + targetoffset;
    ViewData.wizUpdateModel = true;
    this.conditionDS.refresh();
    this.clone.maintenanceFlag = WizMathUtils.createUUID(); // forcer l'update sur modif de children
  }

  /** desactivation des boutons save et cancel sur updateModel */
  public disableButtons(): boolean {
    let result: boolean = true;
    if (this.clone && this.clone.code) {
      result = false;
    }
    if (!result) {
      result = !ViewData.wizUpdateModel;
    }
    return result;
  }

  /** desactivation des boutons save et cancel sur updateModel */
  public disableCancel(): boolean {
    return !ViewData.wizUpdateModel;
  }

  /**
   * Validateur d'unicité du code / shortCode
   */
  public uniqueCodeValidator(): WizValidatorFn {
    return (): WizValidationErrors | null => {
      // Pas de gestion d'erreur si le _clone est null
      if (!this.clone) {
        return null;
      }
      if (this.tiCode.wizValue !== null && this.tiCode.wizValue && this.tiCode.wizValue.length > 0) {
        // CHRONO = mot réservé
        if (this.tiCode.wizValue.toUpperCase() === 'CHRONO') {
          const temp: WizValidationError = {
            wizError: '$.common.keyword.$',
            wizErrorParams: [],
          };
          return [temp];
        }

        // Recherche d'une autre style avec le même code
        let otherStyle: StyleVO = null;
        if (this.model.styleMap.has(this.clone.visionCode)) {
          // check map existe
          otherStyle = this.model.styleMap.get(this.clone.visionCode).get(this.tiCode.wizValue.toUpperCase());
        }

        // Si un style existe deja avec le meme code on affiche le message
        if (otherStyle && otherStyle.uid !== this.clone.uid) {
          const temp: WizValidationError = {
            wizError: '$.style.error.code.unique.$',
            wizErrorParams: [],
          };
          return [temp];
        }
      }
      return null;
    };
  }

  /** ajout d'une condition au style */
  public askForAddLine(): void {
    const newLine: StyleLineVO = this.model.styleEngine.buildFakeLine(this.clone);
    this.clone.addLine(newLine);
    this.conditionDS.addItem(newLine);
  }

  /**
   * modification d'un élément de modèle
   * @param e WizEvent
   */
  private updateModel(e: WizEvent): void {
    switch (e.component) {
      case this.tiCode:
        this.clone.code = this.tiCode.wizValue?.toUpperCase();
        break;
      case this.trsDesc:
        this.clone.descriptionVO.updateTranslationEntry(e.value);
        this.clone.maintenanceFlag = WizMathUtils.createUUID(); // PATCH MAJ SUBCOLL
        break;
      // default: // interception des mauvais update
      //   return;
    }
    this.clone.maintenanceFlag = WizMathUtils.createUUID(); // forcer l'update sur modif de children
    WizEventManager.dispatchEvent(this.elementRef, new AlkEvent(ALK_EVENT_TYPE.UPDATE_MODEL, true));
  }

  /** persistence sur save */
  public doMerge(): void {
    this.model.styleEngine.merge(this.clone, this.currentStyle, this.backFromMerge.bind(this));
  }

  /**
   * Callback sur retour de persistence
   * @param bddBack style créé ou modifié ou supprimé
   * @param operation CUD
   */
  private backFromMerge(vo: StyleVO): void {
    this.currentStyle = vo;
    this.hide();
  }

  /** annulation des modifs */
  public doCancel(): void {
    this.doSaveFlag = false;
    this.hide();
  }

  public onHide() {
    this.wizRemoveListener();
    if (this.doSaveFlag) {
      this.callback(this.currentStyle);
    }
  }
}
